import React, { createElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const ThankYouPage = () => {
  return <div className="min-h-screen bg-black text-white" data-id="element-545">
      <Helmet data-id="element-546">
        <script data-id="element-547">
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1497745688153046');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript data-id="element-548">
          {`<img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=1497745688153046&ev=PageView&noscript=1"
          />`}
        </noscript>
      </Helmet>
      {/* Hero Section */}
      <section className="relative py-16 px-4 sm:px-6 md:px-8" data-id="element-549">
        <div className="max-w-4xl mx-auto text-center" data-id="element-550">
          {/* Logo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} className="mb-8" data-id="element-551">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEuzHiZoD7HHWbnpRvvh2M/516lion.png" alt="516 Partners Logo" className="mx-auto w-20 sm:w-24 md:w-28" data-id="element-552" />
          </motion.div>
          {/* Success Icon */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="mb-6" data-id="element-553">
            <CheckCircleIcon className="w-16 h-16 mx-auto text-[#ffdf07]" data-id="element-554" />
          </motion.div>
          {/* Main Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="typekit-heading text-3xl sm:text-4xl md:text-5xl text-white mb-12" data-id="element-555">
            Your Strategy Call Has Been Booked!
          </motion.h1>
          {/* Steps Section */}
          <div className="space-y-12 text-left" data-id="element-556">
            {/* Step 1 */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.7,
            delay: 0.5
          }} className="bg-gray-900 bg-opacity-50 rounded-lg p-6 sm:p-8 border border-gray-800" data-id="element-557">
              <h2 className="typekit-heading text-3xl sm:text-4xl text-[#ffdf07] mb-4" data-id="element-558">
                Step 1: Confirm Your Call
              </h2>
              <p className="libre-caslon-text-regular text-gray-300 text-lg mb-4 leading-relaxed" data-id="element-559">
                Confirm your call by replying "Yes" to our text or email and
                selecting "Yes" in the email calendar invitation.
              </p>
              <p className="libre-caslon-text-regular text-gray-300 text-lg mb-6 leading-relaxed" data-id="element-560">
                Search your inbox for "Clinic Strategy Call". Click "I
                know the sender" and "Yes" for the calendar invitation.
              </p>
              {/* Calendar Image */}
              <div className="bg-white rounded-lg p-4" data-id="element-561">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/r9DEqwXQsWsGN4KSkKvEHA/pasted-image.webp" alt="Calendar Confirmation Instructions" className="w-full rounded" data-id="element-562" />
              </div>
            </motion.div>
            {/* Step 2 */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.7,
            delay: 0.7
          }} className="bg-gray-900 bg-opacity-50 rounded-lg p-6 sm:p-8 border border-gray-800" data-id="element-563">
              <h2 className="typekit-heading text-3xl sm:text-4xl text-[#ffdf07] mb-4" data-id="element-564">
                Step 2: Prepare your questions in advance.
              </h2>
              <p className="libre-caslon-text-regular text-gray-300 text-lg leading-relaxed" data-id="element-565">
                On the call, we'll be getting to know you, your business, and
                your goals. We want the call to be as helpful to you as possible
                (even if we don't work together), so please have all your
                questions prepared for us in advance so you can leave with
                clarity and confidence.
              </p>
            </motion.div>
            {/* Step 3 */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.7,
            delay: 0.9
          }} className="bg-gray-900 bg-opacity-50 rounded-lg p-6 sm:p-8 border border-gray-800" data-id="element-566">
              <h2 className="typekit-heading text-2xl sm:text-3xl text-[#ffdf07] mb-4" data-id="element-567">
                Step 3: Block out the time so there are no distractions.
              </h2>
              <p className="libre-caslon-text-regular text-gray-300 leading-relaxed" data-id="element-568">
                For this to be a productive call, please give us your full
                attention during the time. If you have other commitments during
                your booked time, feel free to reach out to us and reschedule
                the call.
              </p>
            </motion.div>
          </div>
          {/* Closing Message */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 1.1
        }} className="mt-12 text-center" data-id="element-569">
            <p className="typekit-heading text-xl sm:text-2xl text-white mb-2" data-id="element-570">
              That's it!
            </p>
            <p className="libre-caslon-text-regular text-gray-300 text-lg" data-id="element-571">
              We'll be in touch and talk to you at your booked time.
            </p>
            <div className="mt-6 flex justify-center" data-id="element-572">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8FoTH3xeKncC1VAra4Rj1n/partners516.png" alt="516 Partners Logo" className="h-8 w-auto" data-id="element-573" />
            </div>
          </motion.div>
        </div>
      </section>
      {/* Footer */}
      <footer className="border-t border-gray-800 py-8 px-4 sm:px-6 md:px-8 mt-16" data-id="element-574">
        <div className="max-w-4xl mx-auto text-center" data-id="element-575">
          <p className="text-gray-400 text-sm mb-4" data-id="element-576">
            Copyright © 2025 516 Partners LLC. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mb-4" data-id="element-577">
            This site is not a part of the Facebook™ website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook™ in any way.
            FACEBOOK™ is a trademark of FACEBOOK™, Inc.
          </p>
          <div className="flex justify-center space-x-4" data-id="element-578">
            <a href="#" className="text-gray-500 hover:text-[#ffdf07] text-xs transition-colors" data-id="element-579">
              Privacy Policy
            </a>
            <span className="text-gray-600" data-id="element-580">|</span>
            <a href="#" className="text-gray-500 hover:text-[#ffdf07] text-xs transition-colors" data-id="element-581">
              Terms
            </a>
          </div>
        </div>
      </footer>
    </div>;
};
export default ThankYouPage;